<template>
<div class="search-results">
  <div v-if="ready">
    <div v-if="results.length">
      <h1>Search results</h1>
      <ul>
        <li v-for='e in pagedResults' :key="e.id">
          <h4><router-link :to="getLink(e)">{{e.memberof}}.{{e.name}}</router-link></h4>
          <div v-html="getSummary(e)" class="summary"></div>
        </li>
      </ul>
    </div>
    <div v-else class="search-results_hint">
      <h3>No search results</h3>
      <p><em>Hint: Use a single word. For example "player".</em></p>
    </div>
    <div v-if="hasMore" class="center">
      <button v-on:click="page += 1" class="button">More</button>
    </div>
  </div>
  <div v-else class="center">
    <Spinner class="spinner"/>
  </div>
</div>
</template>

<script>
import Spinner from '../components/Spinner';
import { Docs } from '../utils/docs';
import { stemmer } from 'stemmer';

const PAGE_SIZE = 15;

export default {
  name: 'page-search',
  props: ['query'],
  data () {
    return {
      results: [],
      metadata: null,
      page: 1
    };
  },
  watch: {
    $route (to, from) {
      this.updateResults();
    }
  },
  mounted () {
    if (this.metadata === null) {
      fetch(process.env.VUE_APP_SEARCH_JSON)
        .then(response => {
          return response.json();
        })
        .then(metadata => {
          this.metadata = metadata;
          this.updateResults();
        });
    }
  },
  components: {
    Spinner
  },
  computed: {
    ready () {
      return this.metadata !== null;
    },
    pagedResults () {
      return this.results.slice(0, this.page * PAGE_SIZE);
    },
    hasMore () {
      return this.pagedResults.length < this.results.length;
    }
  },
  methods: {
    updateResults () {
      this.reset();

      if (!this.query) {
        return;
      }

      const phrase = stemmer(this.query.split(' ')[0].toLowerCase().trim());

      const ids = this.metadata[phrase];

      if (!ids) {
        return;
      }

      // Don't use taffy API because it's very slow.
      // Export DB and use native routines.
      const db = this.$store.state.docs.db().get();

      this.results = ids.map(id => db.find(e => e.id === id));
    },
    reset () {
      this.results = [];
      this.page = 1;
    },
    getLink (entry) {
      return Docs.linkTarget(entry);
    },
    getSummary (entry) {
      let summary = Docs.shortSummary(entry).replace('<br>', '').trim();

      // Summary might be cut in the middle.
      // In this case there isn't a closing tag.
      if (summary !== '' && !summary.includes('</p>')) {
        summary += '...</p>';
      }

      return summary;
    }
  }
};
</script>
<style scoped>
.search-results {
  padding: 2rem 4rem;
}

.search-results_hint {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.search-results_hint > h3 {
  margin-top: 2rem;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

h4 {
  margin-bottom: 0.5rem;
}

.summary {
  margin-bottom: 1.5rem;
}

.center {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.spinner {
  width: 10%;
}
</style>
